// extracted by mini-css-extract-plugin
export default {"melodyRule":"eN-z"};